import { render } from "./Contacte.vue?vue&type=template&id=885d6bda&scoped=true"
import script from "./Contacte.vue?vue&type=script&lang=js"
export * from "./Contacte.vue?vue&type=script&lang=js"

import "./Contacte.vue?vue&type=style&index=0&id=885d6bda&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-885d6bda"]])

export default __exports__